<template>
  <div class="golf-protection-form-inner">
    <div class="golf-form-success" v-if="showGreeting">
        <div class="golf-form-svg">
          <svg><use xlink:href="#golf-form-svg"></use></svg>
        </div>
        <h4>Skráning móttekin </h4>
        <p>Þjónustufulltrúi Varðar hefur samband fljótlega</p>
    </div>
    <div class="protection-form" v-else>
      <h4>Golfvernd</h4>
      <p class="sub-text">Sérsniðin trygging gegn þjófnaði á golfbúnaði og öðrum óvæntum atvikum utan vallar sem innan.</p>
      <div class="protection-form">
        <div class="app-form">
          <div class="form-group">
            <input type="number" v-model="protectionFormInfo.name" pattern="/^-?\d+\.?\d*$/" onKeyPress="if(this.value.length==10) return false;" id="name">
            <label for="name">Kennitala</label>
          </div>
          <div class="form-group">
            <input type="email" v-model="protectionFormInfo.email" id="email">
            <label for="email">Netfang</label>
          </div>
          <div class="form-group">
            <input type="mobile" v-model="protectionFormInfo.mobile" maxlength="7" id="mobile">
            <label for="mobile">Símanúmer</label>
          </div>
        </div>
        <div class="facebook" :class="showSkipButton ? '' : 'skip'">
          <button class="button senda" type="button" @click="applyForProtection()">Senda</button>
          <button type="button" class="button nothanx-btn" @click="proceed()">Nei takk, halda áfram</button>
          <a v-if="showSkipButton" href="javascript:history.back()" class="button nothanx-btn form-btn" onclick="closeNav()">Nei takk, halda áfram</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/shared/api'
import { ProtectionForm } from '@/shared/dataModels'
export default {
  name: 'GolfProtectionForm',
  props: {
    'showSkipButton': {
      default: true
    }
  },
  data () {
    return {
      protectionFormInfo: new ProtectionForm(),
      showGreeting: false
    }
  },
  methods: {
    proceed () {
      this.$emit('golfForm', true)
    },
    is_socialSecurity_Number (str) {
      const regexp = /^(?!000|666)[0-8][0-9]{2}-(?!00)[0-9]{2}-(?!0000)[0-9]{4}$/
      if (regexp.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    applyForProtection () {
      if (this.$data.globalData.user && this.$data.globalData.user.email) {
        this.protectionFormInfo.user_email = this.$data.globalData.user.email
      }
      if (this.protectionFormInfo.name === '') {
        const h = this.$createElement
        this.$notify({
          customClass: 'error-msg',
          message: h('i', { style: 'color: #f7653a' }, 'Enter valid input!')
        })
        return
      }
      API.meInstance.post('/apply/golf/protection/', this.protectionFormInfo).then((res) => {
        if (res) {
          if (res.data.status) {
            const h = this.$createElement
              this.$notify({
              customClass: 'success-msg',
              message: h('i', { style: 'color: #6cc65b' }, res.data.data.status)
            })
            this.showGreeting = true
            setTimeout(() => {
                this.$emit('golfForm', true)
                this.showGreeting = false
            }, 4000)
            this.protectionFormInfo = new ProtectionForm()
          } else {
            const h = this.$createElement
            this.$notify({
              customClass: 'error-msg',
              message: h('i', { style: 'color: #f7653a' }, res.data.error)
            })
          }
        }
      }).catch((error) => {
        const h = this.$createElement
        this.$notify({
          customClass: 'error-msg',
          message: h('i', { style: 'color: #f7653a' }, 'Villa, ekki hægt að klára beiðni.')
        })
      })
    },
  }
}
</script>
<style lang="scss" scoped>
    .app-form {
        padding-top: 30px;
    }
    .golf-protection-form-inner {
        position: relative;
        max-width: 600px;
        margin: 0 auto;
        padding-top: 2rem;
        .app-form {
            text-align: left;
        }
        h4 {
            text-align: center;
        }
    }
    .facebook {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        button {
            padding: 1.3rem 9rem;
            border-radius: 10px;
        }
        @media screen and (min-width: 1200px) {
          display: flex;
          justify-content: space-between;
        }
    }
    .form-group {
        input {
            padding: 1.1rem 9rem;
            padding-left: 2rem;
        }
    }
    .golf-form-success {
      p {
        text-align: center;
      }
    }
    .golf-form-svg {
        padding: 4rem 0;
        text-align: center;
        svg {
            width: 101px;
            height: 101px;
        }
    }
    input:-internal-autofill-selected {
        background-color: #FFFFFF !important;
    }
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
        -webkit-appearance: none; 
    }
    @media (max-width: 768px) {
      .golf-protection-form-inner {
        padding-top: 13rem;
      }
    }
</style>
